// Halloween decorations are shown from Oct 31 00:00 until Nov 2 00:00 (browser local time), every year.
const START_MONTH = 9; // October (0-based)
const START_DAY = 31;
const END_MONTH = 10; // November (0-based)
const END_DAY = 2;

// setTimeout overflows above 2^31-1 ms (~24.8 days) and fires immediately, so long waits are chunked.
const MAX_TIMER_MS = 24 * 60 * 60 * 1000;

// QA/support override: localStorage.setItem(FORCE_KEY, 'on' | 'off'); any other value = follow the calendar.
export const HALLOWEEN_FORCE_KEY = 'vooptyHalloween';

export const isHalloweenPeriod = (now: Date): boolean => {
  const year = now.getFullYear();
  const start = new Date(year, START_MONTH, START_DAY);
  const end = new Date(year, END_MONTH, END_DAY);
  return now >= start && now < end;
};

// Milliseconds until the decorations should be re-evaluated (next on/off boundary, capped to one day).
export const msUntilNextCheck = (now: Date): number => {
  const year = now.getFullYear();
  const boundaries = [
    new Date(year, START_MONTH, START_DAY),
    new Date(year, END_MONTH, END_DAY),
    new Date(year + 1, START_MONTH, START_DAY),
  ];
  const next = boundaries.find((boundary) => boundary > now) as Date;
  return Math.min(next.getTime() - now.getTime(), MAX_TIMER_MS);
};

export const readForcedMode = (): 'on' | 'off' | null => {
  try {
    const value = window.localStorage.getItem(HALLOWEEN_FORCE_KEY);
    return value === 'on' || value === 'off' ? value : null;
  } catch (e) {
    // localStorage is unavailable when cookies are disabled — just follow the calendar
    return null;
  }
};

export const shouldShowHalloween = (now: Date): boolean => {
  const forced = readForcedMode();
  if (forced) {
    return forced === 'on';
  }
  return isHalloweenPeriod(now);
};
